import React from 'react';

// Import Montserrat font
import '@fontsource/montserrat/700.css'; // Bold weight

interface JobProtLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function JobProtLogo({ size = 'md', className = '' }: JobProtLogoProps) {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };
  
  return (
    <span
      className={`${sizeClasses[size]} font-montserrat font-bold bg-gradient-to-r from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark bg-clip-text text-transparent cursor-pointer ${className}`}
      onClick={() => { window.open('https://jobprot.com', '_blank'); }}
    >
      JobProt
    </span>
  );
} 